import gql from 'graphql-tag';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const ExercisePageFragment = gql`
  fragment ExercisePageFragment on exercisesPage_Entry {
    image {
      kind
      url
      width
      height
    }
    filterLinkText
    teaserText
    products {
      ... on products_Entry {
        handle: shopifyHandle
        title
      }
    }
    bodyParts {
      ... on bodyParts_Category {
        title
      }
    }
    painPoints {
      ... on painPoints_Category {
        title
      }
    }
    sports {
      ... on sports_Category {
        title
      }
    }
    routineTopics {
      title
    }

    pageProfile
    seoTopics

    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;
